// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__BLi5U","buttons":"RemoveExpirationActionButtons_buttons__jtKG9"};